import { computed }          from 'mobx';
import moment                from 'moment';
import NewFondationsApiModel from 'models/global/NewFondationsApiModel';

export default class EntityModel extends NewFondationsApiModel {
	static get path(): string {
		return '/entities/{?id}';
	}

	@computed
	get createdAt() {
		return this.get('createdAt');
	}

	@computed
	get createdAtMoment() {
		return moment(this.createdAt);
	}

	@computed
	get state() {
		return this.get('state');
	}

	@computed
	get entityType() {
		return this.get('entityType');
	}

	@computed
	get commercialName() {
		return this.get('commercialName', '');
	}

	@computed
	get corporateName() {
		return this.get('corporateName', '');
	}

	@computed
	get provider() {
		return this.get('provider');
	}

	@computed
	get entityCategoryName() {
		return this.get('entityCategory.name');
	}

	@computed
	get activityDomainTitle() {
		return this.get('activityDomain.title');
	}

	@computed
	get identificationNumber() {
		return this.get('identificationNumber');
	}

	@computed
	get intraCommunityNumber() {
		return this.get('intraCommunityNumber');
	}

	@computed
	get website() {
		return this.get('website');
	}

	@computed
	get websiteWithHttps() {
		if (!this.website) {
			return '';
		}

		return this.website.indexOf('https://') > -1
			? this.website
			: 'https://' + this.website;
	}

	@computed
	get corporateAndCommercialName() {
		let corporateAndCommercialName = '';

		if (!!this.corporateName) {
			corporateAndCommercialName = this.corporateName + ' ';
		}

		if (!!this.commercialName) {
			corporateAndCommercialName += `<${this.commercialName}>`;
		}

		return corporateAndCommercialName;
	}
}
